import { Component, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductReleaseService } from '../../services/ProductReleaseService';
import { Subscription } from 'rxjs/Subscription';
import { AdalService } from '../../shared/adal.service';

@Component({
    selector: 'dialog-result-example-dialog',
    template: require('./revision.component.html'),
    styles: [require('./revision.component.css')],
})
export class PageLayoutRevisionComponent {

    private sub: Subscription;
    Title: string;
    ChangeLogData;
    errorMessage: string;

    constructor(private route: ActivatedRoute,
        private router: Router,
        private adalService: AdalService,
        private productRelaseService: ProductReleaseService,
        public dialogRef: MdDialogRef<PageLayoutRevisionComponent>,
        @Inject(MD_DIALOG_DATA) public data: any) {
        document.body.style.overflow="hidden";
        //Check Authentication        
        if (!this.adalService.getCachedToken()) {
            document.body.style.overflow="auto";
            this.dialogRef.close();
            this.router.navigate(['login']);
        }

        if (this.data.SubProductName != '')
            this.Title = this.data.ProductName + " [" + this.data.SubProductName + "]" + "Change Logs Of Product Release No " + this.data.ProductReleaseNo + "";
        else
            this.Title = this.data.ProductName + " Change Logs Of Product Release No " + this.data.ProductReleaseNo + "";
        this.getReleaseDetailById(this.data.productReleaseId);
    }

    getReleaseDetailById(ProductReleaseId: number) {
        this.productRelaseService.getChangeLogDetails(ProductReleaseId).subscribe(
            data => {
                if (!data.IsError && data.DataObject != null) {
                    this.ChangeLogData = data.DataObject;
                }
                else {
                    this.ChangeLogData = null;
                }
            },
            error => {
                this.errorMessage = error;
            });
    }

    onCancel(): void {
        document.body.style.overflow="auto";
        this.dialogRef.close(true);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/page-layouts/revision-changelog/revision.component.ts